import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from 'src/app/core/services/auth/permission.service';

@Directive({
  // disabling as the rule won't fit our existing, and legacy applications of the directive
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[hideIfOne]',
  standalone: false
})
export class HideIfOneDirective {

  private hasView = false;

  //replaced Template<any> with Template<unknown> so the function is limited by an assigned type, and not open to all objects
  constructor(
    private templateRef:TemplateRef<unknown>,
    private viewContainerRef:ViewContainerRef,
    private permissionService:PermissionService
  ) { }

  @Input() set hideIfOne(permissions:string) {

    const isAuthorized = this.permissionService.hasOnePermission(permissions);
    if(!isAuthorized && !this.hasView){
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (isAuthorized && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  }
}

